<template lang="pug">
#tabela-patrimonio-pf
    BaseTableHeader(
        :icone-titulo-tabela='iconeTituloTabela',
        :titulo-tabela='tituloTabela'
    )

    el-collapse(v-model='activeCollapseItem')
        div(v-for='(item, index) in tiposPatrimonio')
            el-collapse-item(:title='item.titulo', :name='index.toString()')
                template(slot='title')
                    | {{ item.titulo }}
                    i.mdi.mdi-minus-circle.ml-2(v-if='!item.temResultados', style='font-size: 20px; color: #686868')
                el-table.table-patrimonio.fixed-header-table(
                    v-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.aeronavesOperador") && dados.aeronavesOperadores',
                    :data='dados.aeronavesOperadores.aeronaves',
                    :default-sort='{ prop: "anoFabricacao", order: "ascending" }',
                    height='100%',
                    style='width: 100%; max-height: 300px; overflow: auto',
                    stripe
                )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.anoDeFabricacao")',
                        prop='anoFabricacao',
                        align='left',
                        sortable,
                        min-width='170px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.fabricante")',
                        prop='fabricante',
                        align='left',
                        min-width='170px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.matricula")',
                        prop='matricula',
                        align='left',
                        min-width='160px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.modelo")',
                        prop='modelo',
                        align='left',
                        min-width='100px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.operador")',
                        prop='operador',
                        :formatter='isEmpty',
                        align='left',
                        min-width='160px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.situacaoDaAeronavegabilidade")',
                        prop='situacaoAeronavegabilidade',
                        align='left',
                        min-width='230px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.situacaoNoRab")',
                        prop='situacaoRAB',
                        align='left',
                        min-width='110px'
                    )
                el-alert(
                    v-else-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.aeronavesOperador") && !dados.aeronavesOperadores',
                    :title='`${$t("mensagens.preAnaliseCredito.naoHaRegistroPara")} ${item.titulo}`',
                    type='warning',
                    :closable='false'
                )
                .tabela-rodape-somatorio(
                    v-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.aeronavesOperador") && dados.aeronavesOperadores'
                )
                    p {{ dados.aeronavesOperadores.aeronaves.length }} aeronaves

                el-table.fixed-header-table(
                    v-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.aeronavesProprietario") && dados.aeronavesProprietarios',
                    :data='dados.aeronavesProprietarios.aeronaves',
                    :default-sort='{ prop: "anoFabricacao", order: "ascending" }',
                    style='width: 100%; max-height: 300px; overflow: auto',
                    stripe
                )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.anoDeFabricacao")',
                        prop='anoFabricacao',
                        align='left',
                        sortable,
                        min-width='170px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.fabricante")',
                        prop='fabricante',
                        align='left',
                        min-width='170px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.matricula")',
                        prop='matricula',
                        align='left',
                        min-width='160px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.modelo")',
                        prop='modelo',
                        align='left',
                        min-width='100px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.proprietario")',
                        prop='proprietario',
                        :formatter='isEmpty',
                        align='left',
                        min-width='160px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.situacaoDaAeronavegabilidade")',
                        prop='situacaoAeronavegabilidade',
                        align='left',
                        min-width='230px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.situacaoNoRab")',
                        prop='situacaoRAB',
                        align='left',
                        min-width='110px'
                    )
                el-alert(
                    v-else-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.aeronavesProprietario") && !dados.aeronavesProprietarios',
                    :title='`${$t("mensagens.preAnaliseCredito.naoHaRegistroPara")} ${item.titulo}`',
                    type='warning',
                    :closable='false'
                )
                .tabela-rodape-somatorio(
                    v-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.aeronavesProprietario") && dados.aeronavesProprietarios'
                )
                    p {{ dados.aeronavesProprietarios.aeronaves.length }} {{ $t('mensagens.preAnaliseCredito.patrimonio.aeronavesMinusculo') }}

                el-table.fixed-header-table(
                    v-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.imoveisRurais") && dados.cafir',
                    :data='dados.cafir.imoveis',
                    :default-sort='{ prop: "area", order: "ascending" }',
                    style='width: 100%; max-height: 300px; overflow: auto',
                    stripe
                )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.area")',
                        prop='area',
                        align='left',
                        sortable,
                        min-width='100px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.informacaoCondominio")',
                        prop='condominioInfo',
                        align='left',
                        min-width='200px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.municipio")',
                        prop='municipio',
                        align='left',
                        min-width='100px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.nirf")',
                        prop='nirf',
                        align='left',
                        min-width='100px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.nomePropriedade")',
                        prop='nome',
                        align='left',
                        min-width='150px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.tipo")',
                        prop='tipo',
                        align='left',
                        min-width='100px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.uf")',
                        prop='uf',
                        align='left',
                        min-width='100px'
                    )
                el-alert(
                    v-else-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.imoveisRurais") && !dados.cafir',
                    :title='`${$t("mensagens.preAnaliseCredito.naoHaRegistroPara")} ${item.titulo}`',
                    type='warning',
                    :closable='false'
                )
                .tabela-rodape-somatorio(
                    v-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.imoveisRurais") && dados.cafir'
                )
                    p {{ dados.cafir.imoveis.length }} {{ $t('mensagens.preAnaliseCredito.patrimonio.imoveisRuraisMinusculo') }}

                el-table.fixed-header-table(
                    v-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.imoveis") && dados.imoveis',
                    :data='dados.imoveis',
                    :default-sort='{ prop: "valorAvaliacao", order: "ascending" }',
                    style='width: 100%; max-height: 300px; overflow: auto',
                    stripe
                )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.valorImovelAvaliado")',
                        prop='valorAvaliacao',
                        :formatter='formatValorAvaliadoTableColumn',
                        align='left',
                        sortable,
                        min-width='100px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.municipio")',
                        prop='endereco.municipio',
                        align='left',
                        min-width='120px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.uf")',
                        prop='endereco.uf',
                        align='left',
                        min-width='60px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.cep")',
                        prop='endereco.cep',
                        :formatter='formatarCep',
                        align='left',
                        min-width='100px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.logradouro")',
                        prop='endereco.logradouro',
                        align='left',
                        min-width='150px'
                    )
                el-alert(
                    v-else-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.imoveis") && !dados.imoveis',
                    :title='`${$t("mensagens.preAnaliseCredito.naoHaRegistroPara")} ${item.titulo}`',
                    type='warning',
                    :closable='false'
                )
                .tabela-rodape-somatorio(
                    v-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.imoveis") && dados.imoveis'
                )
                    p {{ dados.imoveis.length }} {{ $t('mensagens.preAnaliseCredito.patrimonio.imoveisMinusculo') }}

                el-table.fixed-header-table(
                    v-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.perfilVeiculoPesado") && dados.veiculosPesados',
                    :data='dados.veiculosPesados',
                    :default-sort='{ prop: "anoFabricacao", order: "ascending" }',
                    style='width: 100%; max-height: 300px; overflow: auto',
                    stripe
                )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.anoFabricacao")',
                        prop='anoFabricacao',
                        align='left',
                        sortable,
                        min-width='60px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.classificacao")',
                        prop='classificacao',
                        align='left',
                        min-width='100px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.debitos")',
                        prop='debitos',
                        :formatter='formatValorAvaliadoTableColumn',
                        align='left',
                        min-width='60px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.marca")',
                        prop='marca',
                        align='left',
                        min-width='60px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.municipio")',
                        prop='municipio',
                        align='left',
                        min-width='100px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.placa")',
                        prop='placa',
                        align='left',
                        min-width='60px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.renavam")',
                        prop='renavam',
                        align='left',
                        min-width='70px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.tipo")',
                        prop='tipo',
                        align='left',
                        min-width='60px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.uf")',
                        prop='uf',
                        align='left',
                        min-width='50px'
                    )
                el-alert(
                    v-else-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.perfilVeiculoPesado") && !dados.veiculosPesados',
                    :title='`${$t("mensagens.preAnaliseCredito.naoHaRegistroPara")} ${item.titulo}`',
                    type='warning',
                    :closable='false'
                )
                .tabela-rodape-somatorio(
                    v-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.perfilVeiculoPesado") && dados.veiculosPesados'
                )
                    p {{ dados.veiculosPesados.length }} {{ $t('mensagens.preAnaliseCredito.patrimonio.imoveisMinusculo') }}
</template>

<script>
import formatters from '@/utils/formatters';

import preAnaliseServiceMixin from '@/modules/pre-analise-credito/mixins/PreAnaliseCreditoMixin';

import BaseTableHeader from '@/modules/pre-analise-credito/components/BaseTableHeader';

export default {
    name: 'TabelaPatrimonioPf',

    components: {
        BaseTableHeader
    },

    mixins: [preAnaliseServiceMixin],

    props: {
        tituloTabela: {
            type: String,
            required: true,
            default: 'Tabela'
        },
        iconeTituloTabela: {
            type: String,
            required: true,
            default: 'mdi mdi-cloud-search-outline'
        },
        dados: {
            type: Object,
            required: true,
            default: () => {}
        }
    },

    data() {
        return {
            activeCollapseItem: ['0']
        };
    },
    computed: {
        tiposPatrimonio() {
            return this.mxCheckTiposPatrimonioPFResults(this.dados) || [];
        }
    },

    methods: {
        formatarCep(row, column, cep, index) {
            return formatters.formatarCEP(cep);
        },
        formatValorAvaliadoTableColumn(row, column, valorAvaliado, index) {
            return 'R$ ' + formatters.maxFormatNumber(valorAvaliado, 2);
        },
        isEmpty(row, column, data, index) {
            return formatters.isEmpty(data);
        }
    }
};
</script>

<style lang="scss">
#tabela-patrimonio-pf {
    font-family: 'Roboto', 'sans serif' !important;
    border-radius: 5px 5px 0 0 !important;

    h1 {
        border-bottom: 1px solid #359138;
        margin-bottom: 18px;
        width: 100%;
        line-height: 42px;
    }

    .fixed-header-table .el-table__header-wrapper {
        position: sticky;
        top: 0;
        z-index: 1;
    }

    i.mdi {
        color: var(--primary);
        margin-right: 10px;
        font-size: 24px;
    }

    .tabela-titulo {
        color: var(--primary);
        font-size: 18px;
        font-weight: 400;
        line-height: 21px;
        letter-spacing: 0em;
        text-align: left;
    }

    .el-collapse-item {
        border: 1px solid #d9d9d9 !important;
        border-radius: 5px;
        margin-bottom: 12px;
    }

    .el-collapse-item__header {
        position: relative;
        border-radius: 5px;
        height: 35px !important;
        padding: 22px 0px 22px 40px;
        font-size: 16px;
        font-weight: 400;
        line-height: 18px;
    }

    .el-collapse-item__arrow {
        position: absolute;
        left: 10px;
        top: 31%;
        font-size: 16px;
        font-weight: 600;
    }

    .el-collapse-item__wrap {
        padding: 12px;
        border-bottom: none !important;
    }

    .el-table {
        border-radius: 5px;

        .cell {
            word-break: break-word !important;
        }

        .el-table__body-wrapper {
            overflow-x: auto !important;
        }

        .descricao-item-tabela {
            margin-left: 55px;
            margin-right: 55px;
            max-height: 100px;
            overflow-y: auto;
        }

        .el-table__expand-icon {
            height: 24px;
            width: 24px;
            margin-bottom: 10px;
        }

        .el-table__expand-icon > .el-icon {
            color: #3b3b3b;
            font-weight: 700;
            font-size: 16px;
        }

        thead {
            color: var(--primary);
            font-size: 14px;
            font-weight: 500;
            line-height: 16.75px;

            th {
                max-width: 132px;
            }
        }

        .el-descriptions-row {
            .el-descriptions-item__label {
                color: var(--primary);
                font-weight: 500;
                font-size: 16px;
                line-height: 18.75px;
            }
        }
    }

    .table-patrimonio {
        height: 100%;
        width: 100%;
    }

    .tabela-rodape-somatorio p {
        margin-bottom: 0;
        color: var(--primary);
        font-size: 14px;
        font-weight: 500;
        line-height: 16px;
        margin-left: 21px;
        padding-top: 17px;
    }

    .el-collapse-item__content {
        padding-bottom: 5px !important;
    }
}
</style>
